// Official brand SVG logos for each payment method actively enabled in Stripe.
// Files live under /public/payment-logos/ and are sourced from:
//  - Visa, Mastercard, Apple Pay, Google Pay: datatrans/payment-logos (MIT)
//  - Multibanco: Wikimedia Commons (Public Domain / SIBS)
//  - MB WAY: mbway.pt official asset (colors inverted to display on light pill)

const METHODS = [
  { id: "visa", label: "Visa", src: "/payment-logos/visa.svg" },
  { id: "mastercard", label: "Mastercard", src: "/payment-logos/mastercard.svg" },
  { id: "multibanco", label: "Multibanco", src: "/payment-logos/multibanco.svg" },
  { id: "mbway", label: "MB WAY", src: "/payment-logos/mbway.svg" },
  { id: "applepay", label: "Apple Pay", src: "/payment-logos/apple-pay.svg" },
  { id: "googlepay", label: "Google Pay", src: "/payment-logos/google-pay.svg" },
  { id: "revolutpay", label: "Revolut Pay", src: "/payment-logos/revolut-pay.svg" },
  { id: "klarna", label: "Klarna", src: "/payment-logos/klarna.svg" },
];

// Methods whose SVG already carries its own white card background.
// We render them flush, without an extra container.
const HAS_BUILT_IN_BG = new Set(["visa", "mastercard", "applepay", "googlepay", "klarna"]);

export default function PaymentBadges() {
  return (
    <div
      data-testid="payment-badges"
      className="flex flex-wrap items-center justify-center md:justify-start gap-2"
      aria-label="Métodos de pagamento aceites"
    >
      {METHODS.map((m) => {
        const flush = HAS_BUILT_IN_BG.has(m.id);
        return (
          <div
            key={m.id}
            data-testid={`payment-badge-${m.id}`}
            className={
              flush
                ? "h-10 flex items-center"
                : "h-10 px-3.5 rounded-md bg-white border border-line flex items-center justify-center"
            }
            style={!flush ? { minWidth: 64 } : undefined}
          >
            <img
              src={m.src}
              alt={m.label}
              loading="lazy"
              decoding="async"
              className={flush ? "h-10 w-auto" : "h-5 w-auto"}
            />
          </div>
        );
      })}
    </div>
  );
}
